// extracted by mini-css-extract-plugin
export default {"container":"MessageCenter_container__NFPe0","users":"MessageCenter_users__CdLL2","messages":"MessageCenter_messages__pPbaT","location":"MessageCenter_location__ud3JH"};